<template>
    <div id="rule-modal" tabindex="-1" role="dialog" class="rule-modal modal fade in">
        <div role="document" class="modal-dialog modal-sm">
            <div class="modal-content">
                <div class="modal-header text-center">
                    <button type="button" data-dismiss="modal" aria-label="Close" class="close">
                    <span aria-hidden="true">×</span>
                    </button>
                    <h2 class="text-white">NOTE</h2>
                </div>
                <div class="modal-body text-white">
                    <template v-for="(text, index) in ruleText">
                        <p class="text-center" :key="'rule-modal-' + index">
                            {{ text }}
                        </p>
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapGetters, mapActions, mapState } from "vuex";
export default {
    name: "RulesHandler",
    data() {
        return {
            ruleText: []
        };
    },
    props: {
        sessionData: {
            type: Object
        },
    },
    computed: {
        ...mapState({
            activeBuild: state => state.Step4.activeBuild
        }),
        ...mapGetters(["buildPrice", "activeRules", "previousBuild", "isPreventRule", "previousPartQuantity"]),
    },
    watch: {
        activeRules: {
            handler() {
                this.applyRules();
            },
            deep: true
        }
    },
    methods: {
        ...mapActions(["changeBuildPart", "setBuildPrice", "pushBuildPart", "removeBuildPart", "setActiveBuild", "changePreventRuleValidator"]),
        applyRules() {
            const rules = _.cloneDeep(this.activeRules);

            if (rules.length) {
                this.ruleText = [];

                rules.forEach((element) => {
                    if (!["disable", "disable-all", "enable", "enable-all"].includes(element.ruleType)) {
                        this.ruleText.push(element.msg);
                    }
                });

                if (this.ruleText.length) {
                    $("#rule-modal").modal();
                }
            } else {
                return;
            }
        },
        applySwitchRule(element, newPart) {
            if (newPart) {
                let partName = element.partToChange;

                if (!this.activeBuild[partName]) {

                    if (element.partToChange == "fans") {
                        partName = "caseFans";
                    } else if (element.partToChange == "psus") {
                        partName = "powerSupply";
                    } else if (element.partToChange == "coolers") {
                        partName = "cpuCooler";
                    } else {
                        partName = element.partToChange.substring(0, element.partToChange.length - 1);
                    }

                }

                if (element.products && element.products.quantity) {
                    newPart.quantity = element.products.quantity;
                }

                if (this.activeBuild[partName]) {
                    if (_.isArray(this.activeBuild[partName])) {
                        if (partName == "storage") {
                            if (element.products.storage_types_id == "2") {
                                partName = "ssd";
                            } else {
                                partName = "hdd";
                            }
                        }
                        let partToChangeIndex = this.getBuildPartIndex(element.products.products_id, partName);
                        if (partToChangeIndex >= 0) {
                            let part = _.cloneDeep(this.activeBuild[partName]);
                            part[partToChangeIndex] = newPart;
                            this.changeBuildPart( { partName: partName, part: part });
                        }
                    } else {
                        this.changeBuildPart( { partName: partName, part: newPart });
                    }
                }
            }
        },
        applyPreventRule(element, newPart) {
            this.changePreventRuleValidator(true);
            const partName = element.partToChange;
            if (partName === "fans") {
                const indexPart = this.getBuildPartIndex(newPart.products_id, "caseFans");
                let part = _.cloneDeep(this.activeBuild["caseFans"]);
                part[indexPart].quantity = this.previousPartQuantity;
                this.changeBuildPart( { partName: "caseFans", part: part });
            }   else if(partName === "ram") {
                let part = _.cloneDeep(this.activeBuild[partName]);
                part.quantity = element.products.quantity;
                this.changeBuildPart( { partName: partName, part: part });
            }
            this.setActiveBuild(this.previousBuild);
        },
        applyResetRule(element, newPart) {

            if (element.partToChange == "fans") {
                if (element.fan_color == "RGB") {
                    let filteredFans = this.activeBuild.caseFans.filter(fan => {
                        return fan.colors != "RGB";
                    });
                    this.changeBuildPart( { partName: "caseFans", part: filteredFans });
                }

                if (element.size) {
                    let filteredFans = this.activeBuild.caseFans.filter(fan => {
                        return fan.size != element.size;
                    });
                    this.changeBuildPart( { partName: "caseFans", part: filteredFans });
                }

                if (element.fan_color !== "RGB" && !element.size) {
                    this.changeBuildPart( { partName: "caseFans", part: [] });
                }

                return;
            }

            let partName = element.partToChange;

            if (element.partToChange == "storage") {
                if (element.storage_types == "ssd") {
                    partName = "ssd";
                } else {
                    partName = "hdd";
                }
            }

            if (!this.activeBuild[partName]) {
                if (element.partToChange == "fans") {
                    partName = "caseFans";
                } else {
                    partName = element.partToChange.substring(0, element.partToChange.length - 1);
                }
            }

            if (this.activeBuild[partName]) {
                if (_.isArray(this.activeBuild[partName])) {
                    this.changeBuildPart( { partName: partName, part: [] });
                } else {
                    this.changeBuildPart( { partName: partName, part: {} });
                }
            }
        },
        applyAddRule(element, newPart) {
            if (newPart) {
                if (element.products && element.products.quantity) {
                    newPart.quantity = element.products.quantity;
                }

                let partName = element.partToChange;

                if (!this.activeBuild[partName]) {
                    if (element.partToChange == "fans") {
                        partName = "caseFans";
                    } else {
                        partName = element.partToChange.substring(0, element.partToChange.length - 1);
                    }
                }

                if (this.activeBuild[partName]) {
                    if (_.isArray(this.activeBuild[partName])) {
                        this.pushBuildPart({ partName: partName, part: newPart });
                    } else {
                        this.changeBuildPart({ partName: partName, part: newPart });
                    }
                }
            }
        },
        findBuildPart(productId, partName) {
            if (partName == "cpus") {
                partName = "cpu";
            } else if (partName == "gpus") {
                partName = "gpu";
            } else if (partName == "cases") {
                partName = "case";
            } else if (partName == "psus") {
                partName = "powerSupplies";
            } else if (partName == "coolers") {
                partName = "cooling";
            }

            return this.sessionData[partName].find(
                (element) => {
                    return element && element.products_id == productId;
                }
            );
        },
        getBuildPartIndex(productId, part) {
            return _.findIndex(this.activeBuild[part], {
                products_id: productId
            });
        }
    }
}
</script>


<style lang="scss" scoped>
.rule-modal {
    padding-right: 0 !important;
}
</style>
